module.exports = _.has;